import React from "react"
import "../../styles/delimiter.scss"

const Delimiter = ({ type, text, subText }) => {
    return <div id={type ? type : ""} className="textDelimiter" style={{paddingBottom: subText ? "20px" : null}}>
        <div className="line" />
        <div className="title">{text}</div>
        {subText ? <div className="subTitle">{subText}</div> : null}
    </div>
}

export default Delimiter